"use strict";

exports.__esModule = true;
exports.default = void 0;

const getFieldDataState = error => error ? "error" : "ok";

var _default = getFieldDataState;
exports.default = _default;